import { ApiVersion } from "../const";
import { Instalation } from "../models/Instalation";
import { Company } from "../models/Company";
import { ColumnFiltersState } from "@tanstack/react-table";

export const getAllInstalations = (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllInstalations`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

export const getInstalationsPage = (
    token: string,
    page: number,
    limit: number,
    filters: ColumnFiltersState, // Same type as machines
    sortBy: string,
    sortDir: string
) => {
    const filt = JSON.stringify(filters);
    const url =
        `${process.env.REACT_APP_API_URL}${ApiVersion}getInstalationsPage` +
        `?page=${page}&limit=${limit}&filters=${filt}&sortBy=${sortBy}&sortDir=${sortDir}`;
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    }).then(r => (r.ok ? r.json() : Promise.reject(r)));
};

export const getAllInstalationsByCompany = (token: string, company: Company, iDate: string, fDate: string, activeData: boolean) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate: iDate, finDate: fDate, active: activeData })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllInstalationsByCompany/${company.idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

export const getInstalationsByCompany = (token: string, idcompany: number) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getInstalationsByCompany/${idcompany}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const createInstalation = (token: string, instalation: Instalation) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(instalation)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}createInstalation/${instalation.idinstalation}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const deleteInstalation = (token: string, idinstalation: number) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}deleteInstalation/${idinstalation}`, requestOptions)
}


export const getAllInstalationStates = (token: string, idinstalation: number, iniD: string, endD: string) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ iniDate: iniD, finDate: endD })
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllInstalationStates/${idinstalation}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

